var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopgirl01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#be5521;}.cls-2{fill:#f4e211;}.cls-3{fill:#2ca0ff;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-6{fill:#f5f1e5;}.cls-7{fill:#ebc2ff;}.cls-8{clip-path:url(#clip-path-2);}.cls-9{clip-path:url(#clip-path-3);}.cls-10{fill:#fff;}.cls-11{clip-path:url(#clip-path-4);}.cls-12{clip-path:url(#clip-path-5);}.cls-13{fill:#ff715d;}.cls-14{clip-path:url(#clip-path-6);}.cls-15{clip-path:url(#clip-path-7);}.cls-16{clip-path:url(#clip-path-8);}.cls-17{clip-path:url(#clip-path-9);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 567.51,
    cy: 322.58,
    rx: 69.56,
    ry: 72.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M714.3,141.32c-8.44,28.1-34.18,126.19-19.85,237.48L591.18,445.92v18.61l211.7,96.36,160.24-152a11.27,11.27,0,0,0,3.47-9.27C964.32,376,958.48,278.89,1004,190.31a12,12,0,0,0-1-12.57l-7.05-9.56S834.44,127.84,725.29,132.8A12,12,0,0,0,714.3,141.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M727.63,168.36a14.78,14.78,0,0,1,14.54-12.08,847.36,847.36,0,0,1,205.45,25.49,14.8,14.8,0,0,1,10.49,18.89c-4,12.45-7.77,25.46-11.19,39a778.26,778.26,0,0,0-20.44,121.52,14.8,14.8,0,0,1-16,13.5L723.63,358.53A14.8,14.8,0,0,1,710.17,345C708.37,323.91,708.22,272.87,727.63,168.36Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M193.59,911.45l-82.34,14.82a48.47,48.47,0,0,0-39.43,54.31l17.83,129.6c5.76,41.82,55,61.7,87.89,35.22,16.93-13.63,33.42-35.19,45.87-69,28.62-23.47,41.59-60.93,33.3-96.26C244.88,929.75,196.55,912.45,193.59,911.45Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.43,1159.27l-47.36,64a58.12,58.12,0,0,0,11.18,80.59l111,85.74c30.91,23.87,76.31,4.84,80.49-34,2.79-25.93-1.82-56.21-23.84-86.56,14.62-37.17,3.28-79.61-27.57-104.09C290.71,1141.44,249,1139.11,216.43,1159.27Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M795.21,456c13.48-3.63,26.92-8.41,38-16.87s19.67-21.08,20.51-35-7.49-28.68-20.84-32.76c9.46-14.07,9.31-33.94-.36-47.86s-28.24-21-44.73-17.05a36.31,36.31,0,0,0-8.81-63.1c-11.86-4.49-25.48-2.41-36.82,3.27s-20.69,14.65-29.08,24.15c-22.09,25-39,55.51-43.4,88.59s4.94,68.76,28.67,92.22,71.77,34.24,96.83,4.42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M775.85,586.89C795,597.14,817.56,600,839.12,597.41c48.47-5.77,92.5-39.88,110.2-85.37,5.21-13.38,8.29-27.9,6.49-42.15s-8.93-28.21-20.86-36.21-28.8-9-40.49-.64a32.47,32.47,0,0,0-45.33,32.66c-13.42-3.85-29.07,2.44-36.1,14.51s-7.36,25.86,2.62,35.63a120.87,120.87,0,0,0-19.5,17.53c-11.07-8.88-25.49-15.06-39.75-18.58a13.09,13.09,0,0,0-15.52,8.53,39.82,39.82,0,0,0,2.77,32.14A79.72,79.72,0,0,0,775.85,586.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.5,315.9c-6.12,8.76-4.3,18.52-.09,21.08s13.85-.33,18.76-10Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 522.8,
    cy: 326.89,
    r: 16.76
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "laptop girl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 567.51,
    cy: 322.58,
    rx: 69.56,
    ry: 72.91
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M609.53,287.45l9.43,9.93a6.24,6.24,0,1,1,8.3,9.31"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 586,
    cy: 310.13,
    r: 5.18
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M450.48,376s33.93-39.11,104.44-6.54c0,0,51.36,24.46,20,61.93l20.85,47.45L478.25,660.11s-85.89-86.68-198.15-53.45C280.1,606.66,275,432.93,450.48,376Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "lapto"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M714.3,141.32c-8.44,28.1-34.18,126.19-19.85,237.48L591.18,445.92v18.61l211.7,96.36,160.24-152a11.27,11.27,0,0,0,3.47-9.27C964.32,376,958.48,278.89,1004,190.31a12,12,0,0,0-1-12.57l-7.05-9.56S834.44,127.84,725.29,132.8A12,12,0,0,0,714.3,141.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1001.6,161.83s-54.84,75.74-49.68,236.87L796.36,536.52l-215-94.21-6.21,33.87,234.31,97.64L975,409.66l4.63-103,45.09-123.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M727.63,168.36a14.78,14.78,0,0,1,14.54-12.08,847.36,847.36,0,0,1,205.45,25.49,14.8,14.8,0,0,1,10.49,18.89c-4,12.45-7.77,25.46-11.19,39a778.26,778.26,0,0,0-20.44,121.52,14.8,14.8,0,0,1-16,13.5L723.63,358.53A14.8,14.8,0,0,1,710.17,345C708.37,323.91,708.22,272.87,727.63,168.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 738.76,
    y: 193.95,
    width: 134.22,
    height: 19.07,
    rx: 9.54,
    transform: "translate(26.89 -86.38) rotate(6.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 797.89,
    y: 247.15,
    width: 134.22,
    height: 19.07,
    rx: 9.54,
    transform: "translate(33.02 -92.49) rotate(6.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 766.25,
    y: 300.59,
    width: 134.22,
    height: 19.07,
    rx: 9.54,
    transform: "translate(38.64 -88.74) rotate(6.24)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 817.17,
    y1: 381.82,
    x2: 932.21,
    y2: 391.66
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "shoe_1",
    "data-name": "shoe 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M193.59,911.45l-82.34,14.82a48.47,48.47,0,0,0-39.43,54.31l17.83,129.6c5.76,41.82,55,61.7,87.89,35.22,16.93-13.63,33.42-35.19,45.87-69,28.62-23.47,41.59-60.93,33.3-96.26C244.88,929.75,196.55,912.45,193.59,911.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.73,950.12c-21.87,7.23-42.17,23.41-48,45.69-3.8,14.54-1.16,29.9,1.5,44.69q8.48,47.25,17,94.49c1.58,8.79,3.22,17.75,7.5,25.58s11.74,14.48,20.62,15.39c13,1.34,24.45-10.11,27.81-22.71s.64-25.91-2.08-38.65l-15-70.4c-2.68-12.56-5.05-26.8,2.34-37.3,15-21.31,55.3-8.38,69.4-30.31,9-14-.66-30.9-15.25-33.28C199.42,940,172.9,943.79,153.73,950.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.72,940s5.76,32.64-25.39,32.64L102,1125.47"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "shoe_2",
    "data-name": "shoe 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.43,1159.27l-47.36,64a58.12,58.12,0,0,0,11.18,80.59l111,85.74c30.91,23.87,76.31,4.84,80.49-34,2.79-25.93-1.82-56.21-23.84-86.56,14.62-37.17,3.28-79.61-27.57-104.09C290.71,1141.44,249,1139.11,216.43,1159.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.53,1211.12c-12.41,15-21,34.07-19.33,53.43,1.3,15,8.65,29,18.24,40.6s21.42,21.15,33.15,30.61l64.13,51.71c10.71,8.63,23.8,17.81,37,14.1,10.17-2.86,17.1-13.24,17.93-23.77s-3.57-21-10-29.35-14.76-15.09-23-21.69l-53.4-42.69c-10.55-8.44-22.08-18.83-21.89-32.33.18-13.29,11.57-23.23,21.24-32.33s19.16-22.16,14.48-34.59c-2.56-6.77-9.11-11.57-16.18-13.13C275.14,1166.66,248.58,1195.43,235.53,1211.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M173.53,1237.93s24.36,17.1,0,41.45l137.85,109.35"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "lower_leg_2",
    "data-name": "lower leg 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M216.43,1159.27l77.34-127.6,261.15-29.81s-118.19,165.58-207,267.15C347.88,1269,302.85,1188.92,216.43,1159.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243.07,1148.15s65.14,14.51,107.7,88.22"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "thigh_2",
    "data-name": "thigh 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M280.1,606.66S74.51,698.61,315.85,940l140.08-57.53L280.1,606.66"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "thigh_1",
    "data-name": "thigh 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M280.1,606.66S111.86,824.15,534,1001.86c55.25,23.26,116.4-19.26,113.09-79.11-1-17.65-5.86-38.17-16.43-62,0,0-60.91-147.88-152.39-200.69C478.25,660.11,391.33,570.32,280.1,606.66Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "lower_leg",
    "data-name": "lower leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M193.59,911.45,493.68,828c2.73-.9,63.77-19.77,112.05,22.8.73.64,1.44,1.29,2.14,1.94,40,37.09,50.73,94.08,15.32,135.56-8.82,10.35-26,24.34-36,30.14-53.59,31-158.5,61.28-363.78,57.94C223.41,1076.39,227.85,970.79,193.59,911.45Z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "upper_arm",
    "data-name": "upper arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M399.32,465.78c.31-.73.62-1.46.95-2.19,24.63-55.18,97-63.78,135-16.62,20.41,25.35,42.87,67.82,59.76,138.92a128.45,128.45,0,0,1-1.79,67.41c-9.82,31.79-34.21,64.89-94.66,43.16,0,0-68-21.85-103.84-157.05C388.21,514.94,389.62,488.87,399.32,465.78Z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "lower_arm",
    "data-name": "lower arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M555.89,704.58c33-3.21,71.87-21.34,112.42-70.5,0,0,67-67.5,92.92-164.55l-78.8-59.87s-132.1,56.25-197.91,190.62C459.68,651,499.68,710.05,555.89,704.58Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.41,219.38c-30.37,1.43-59,13.52-87.88,23.18a576.25,576.25,0,0,1-227.61,28c-27.22-2.13-54.6-6.21-81.69-2.79s-54.64,15.74-68.86,39S67.44,365.33,91,379.09c21.77,12.72,49.13,4,73.25-3.36a531.75,531.75,0,0,1,127.48-22.19c9.95-.5,20.23-.66,29.5,3s17.34,12.05,17.65,22c.46,14.68-15,24.71-29.35,28-15.46,3.59-31.52,3.05-47.37,3.81s-32.2,3-45.63,11.47-23.21,24.42-20.12,40c2.65,13.38,14.2,23.69,27.07,28.23s26.92,4.17,40.5,2.8c73-7.38,141-42.36,199-87.4,16.71-13,32.9-27,45.38-44.1s21.08-37.61,21.07-58.77c0-12.34-.63-28.59,11-32.59l6.48,24.24c.16.59,81-20.21,70.14-43.8C605.89,226.2,566.73,218.27,543.41,219.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.08,198.91c-8.31-11-11.69-26.14-7-39.13S450.2,137,464,138.17c11.71,1,21.55,9.24,29.12,18.23,6.86,8.15,12.67,17.5,14.87,27.92s.37,22.06-6.56,30.15C484.46,234.21,451.44,215.3,439.08,198.91Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "fingers_2",
    "data-name": "fingers 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M795.21,456c13.48-3.63,26.92-8.41,38-16.87s19.67-21.08,20.51-35-7.49-28.68-20.84-32.76c9.46-14.07,9.31-33.94-.36-47.86s-28.24-21-44.73-17.05a36.31,36.31,0,0,0-8.81-63.1c-11.86-4.49-25.48-2.41-36.82,3.27s-20.69,14.65-29.08,24.15c-22.09,25-39,55.51-43.4,88.59s4.94,68.76,28.67,92.22,71.77,34.24,96.83,4.42"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M822,417.18c-.29-4.39-4-8.15-8.26-9.14a14.63,14.63,0,0,0-12.31,3.27,23.74,23.74,0,0,0-7,11c-3.5,10.51-1.77,22,0,32.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M787.82,306.43c-17,3.34-27.11,10.1-39.83,21.89a94.57,94.57,0,0,0-26.68,43.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M713.53,372.63a19.46,19.46,0,0,1,14.83,5.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M832.21,373.15c-9.66-2.89-13.69-4.1-23.75-4.5a61.35,61.35,0,0,0-53.16,27.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M746.71,394.87a15.66,15.66,0,0,1,15.45,9.55"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "fingers_1",
    "data-name": "fingers 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M775.85,586.89C795,597.14,817.56,600,839.12,597.41c48.47-5.77,92.5-39.88,110.2-85.37,5.21-13.38,8.29-27.9,6.49-42.15s-8.93-28.21-20.86-36.21-28.8-9-40.49-.64a32.47,32.47,0,0,0-45.33,32.66c-13.42-3.85-29.07,2.44-36.1,14.51s-7.36,25.86,2.62,35.63a120.87,120.87,0,0,0-19.5,17.53c-11.07-8.88-25.49-15.06-39.75-18.58a13.09,13.09,0,0,0-15.52,8.53,39.82,39.82,0,0,0,2.77,32.14A79.72,79.72,0,0,0,775.85,586.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M848.44,463.35a68.89,68.89,0,0,1,32.45,86.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M896.05,432.51c20.87,21.42,27.33,55.65,15.7,83.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M873.26,548.54a13.63,13.63,0,0,0,16.62.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M904.28,516.49a11,11,0,0,0,13.46-.93"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "eyebroes"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 593.29,
    cy: 289.57,
    rx: 10.62,
    ry: 5.84,
    transform: "translate(5.18 589.52) rotate(-53.04)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 621.74,
    cy: 274.48,
    rx: 10.62,
    ry: 5.84,
    transform: "matrix(1, -0.1, 0.1, 1, -23.35, 60.58)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "eyes"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 601.19,
    cy: 301.23,
    rx: 3.64,
    ry: 5.04
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "eyes_2",
    "data-name": "eyes 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 629.15,
    cy: 288.56,
    rx: 3.17,
    ry: 4.85
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "mouth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.5,315.9c-6.12,8.76-4.3,18.52-.09,21.08s13.85-.33,18.76-10Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M591.31,331.18s17.55-9.07,17.55,12.78C608.86,344,592.6,342.94,591.31,331.18Z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "ear"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 522.8,
    cy: 326.89,
    r: 16.76
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M514,323.78c.06-.24,1.6-5.38,6.7-6.74a9.65,9.65,0,0,1,10.14,3.63"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M247.05,708.53s-16.32,84.1,81,165.53l-57.66,16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 591.01,
    y1: 468.05,
    x2: 534.15,
    y2: 527.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M574.91,431.4S545.18,388.73,477,388.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M523.53,1045.08s-119.44,31.31-262.7,31.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M423,615.19s42.74,104.64,139.7,88.25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopgirl01);
export default __webpack_public_path__ + "static/media/laptop girl-01.ce8a33ad35a0339fde065e8aafb0776d.svg";
export { ForwardRef as ReactComponent };